import React, { useCallback, useEffect, useRef, useState, Fragment } from 'react';
import ReactCanvasConfetti from 'react-canvas-confetti';

const canvasStyles = {
  position: 'absolute',
  pointerEvents: 'none',
  width: '100%',
  height: '100%',
  inset: 0,
  zIndex: 0,
};

function getAnimationSettings(angle, originX) {
  return {
    particleCount: 3,
    angle,
    spread: 50,
    origin: { x: originX },
    colors: ['#2575fc', '#fff', '#dc3545'],
  };
}

export default function InfoBarConfetti() {
  const refAnimationInstance = useRef(null);
  const [intervalId, setIntervalId] = useState();
  const [animate, setAnimate] = useState(true);

  const getInstance = useCallback((instance) => {
    refAnimationInstance.current = instance;
  }, []);

  const nextTickAnimation = useCallback(() => {
    if (refAnimationInstance.current) {
      refAnimationInstance.current(getAnimationSettings(50, 0));
      refAnimationInstance.current(getAnimationSettings(100, 1));
    }
  }, []);

  const pauseAnimation = () => {
    clearInterval(intervalId);
    setIntervalId(null);
  };

  const startAnimation = useCallback(() => {
    if (!intervalId) {
      setIntervalId(setInterval(nextTickAnimation, 100));
    }
    // setTimeout(() => {
    //   pauseAnimation();
    //   setAnimate(false);
    // }, 2000);
  }, [nextTickAnimation, intervalId]);

  useEffect(() => {
    return () => {
      clearInterval(intervalId);
    };
  }, [intervalId]);

  return (
    <Fragment>
      {animate && startAnimation()}
      <ReactCanvasConfetti refConfetti={getInstance} style={canvasStyles} />
    </Fragment>
  );
}
